module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';
	
	fox.registerWidget('Mixin', {
		configure: function(options) {
			this._hooks = {};
			this.callParent('configure', arguments);
		},

		hook: function(alias, wom, eventName, myMethod, params) {
			params = params || {};
			params.performer = this;
			params.prefix = this.getHash();

			this._hooks[alias] = this.getEm().handleHook(wom, eventName, fox.bind(this[myMethod], this), params);
		}
	}, 'Controller');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/mixin.js
// module id = 208
// module chunks = 0